// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import {Drawer,Modal} from 'ant-design-vue';
import 'element-ui/lib/theme-chalk/index.css';
import "babel-polyfill"
import {
  post,
  get,
} from './api/index'
import utils from'./utils.js'
import axios from 'axios'

import zyxTable from './common/table'
import newTable from './common/newTable'
Vue.component('zyxTable', zyxTable)
Vue.component('newTable', newTable)
axios.defaults.timeout =  900000;

let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
function _utf8_encode(string) {
  string = string.replace(/\r\n/g, "\n");
  var utftext = "";

  for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
          utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
      } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
      }

  }

  return utftext;
};

function encode(input) {
  var output = "";
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;

  input = _utf8_encode(input);

  while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
          enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
          enc4 = 64;
      }

      output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

  }

  return output;
};

axios.interceptors.request.use(config => {
  // 在请求发送前做处理
  if (sessionStorage.token) {
      config.headers['Authorization'] = sessionStorage.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }
  //  if (sessionStorage.userName) {
  //   config.headers['Authorization'] = encode(sessionStorage.userName); // 发送用户名 后台记录该用户调用哪些接口
  // }

  return config;
}, error => {
  console.log(error)

  //请求失败后的操作
  Promise.reject(error);
  ElementUI.Message({
    type: 'error',
    message: '请求失败，请稍后再试',
  })
})

Vue.use(ElementUI);
Vue.use(Drawer);
Vue.use(Modal);


// Vue.use(ant)
// respone拦截器
axios.interceptors.response.use(

  response => {

      const res = response.data;
      if(res.code == '1001'){
        router.replace({
          path: '/'
        })
      }
      if(res.response){
        if(res.response.code == 'A1004'){
          router.replace({
            path: '/'
          })
        }
        if(res.response.code == 'A1008'){
          router.replace({
            path: '/'
          })
        }
      }
      if(res.code == '1001'){
        router.replace({
          path: '/'
        })
      }
      if (response.status === 401 || res.status === 40101) {
          
          return Promise.reject('error');
      }
      if (res.status === 40301) {
          
          return Promise.reject('error');
      }
      if (response.status !== 200 && res.status !== 200) {
          
      } else {
          return response.data;
      }
  },
  error => {
    ElementUI.Message({
      type: 'error',
      message: '请求失败，请稍后再试',
    })
    return Promise.reject(error);
  }
);
//以原型链的方式绑定请求方法
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$axios = axios
Vue.prototype.$utils = utils
// Vue.prototype.url = "http://192.168.23.48"
Vue.prototype.url = "https://"+window.location.host
// Vue.prototype.url = "http://bohui-dev.apps.aiyisheng.com.cn"
// Vue.prototype.url = "http://test.aiyisheng.com.cn"
Vue.prototype.hostAuth = "/dms-gateway/dms_auth"
Vue.prototype.hostDms = "/dms-gateway/dms"
Vue.prototype.dearOrgPid = "366"


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js